import { render, staticRenderFns } from "./GoodsSocksAdminView.vue?vue&type=template&id=1a513fdd&"
import script from "./GoodsSocksAdminView.vue?vue&type=script&lang=js&"
export * from "./GoodsSocksAdminView.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSocksAdminView.vue?vue&type=style&index=0&id=1a513fdd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports